



























































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Delta, DeltaType } from '@/models/Delta';

@Component
export default class DeltaValueField extends Vue {
    @Prop({ required: false, default: 'text' })
    public type!: 'text' | 'chip';

    @Prop({ required: false })
    public deltaType?: DeltaType;

    @Prop({ required: false })
    public originalValue?: any;

    @Prop({ required: false })
    public delta?: Delta;

    @Prop({ required: false })
    public top?: boolean;

    @Prop({ required: false })
    public left?: boolean;

    @Prop({ required: false })
    public right?: boolean;

    @Prop({ required: false })
    public bottom?: boolean;

    public get effectiveDeltaType(): DeltaType {
        return this.delta?.deltaType ?? this.deltaType;
    }

    public get effectiveOriginalValue(): any {
        return this.delta?.originalValue ?? this.originalValue;
    }

    public get hasDelta(): boolean {
        const deltaType = this.effectiveDeltaType;
        return deltaType === 'Added' || 
               deltaType === 'Changed' || 
               deltaType === 'Removed';
    }


}
